// As cores aqui são da paleta:
// <https://flatuicolors.com/palette/defo>

export const purple = '#8e44ad'

export const blue = '#5e7083'

export const lightBlue = '#2980b9'

export const orange = '#e67e22'

export const darkOrange = '#d35400'
